var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 27.8068C22.4934 27.8068 28.3064 22.0061 28.3064 15C28.3064 8.00627 22.4805 2.19324 15.4868 2.19324C8.48122 2.19324 2.69336 8.00627 2.69336 15C2.69336 22.0061 8.49354 27.8068 15.4996 27.8068ZM15.5001 25.6725C9.573 25.6725 4.8389 20.9261 4.8389 15C4.8389 9.08574 9.56015 4.32752 15.4868 4.32752C21.4005 4.32752 26.1587 9.08627 26.1716 15C26.1839 20.9266 21.4128 25.6725 15.4991 25.6725M15.4868 17.2725C16.0889 17.2725 16.428 16.9334 16.4403 16.2809L16.6289 9.65145C16.6418 9.01074 16.1393 8.53395 15.4739 8.53395C14.7957 8.53395 14.3189 8.99842 14.3312 9.6386L14.4946 16.2809C14.5069 16.9211 14.8589 17.2725 15.4868 17.2725ZM15.4868 21.3531C16.2019 21.3531 16.8421 20.7756 16.8421 20.0475C16.8421 19.3066 16.2148 18.7415 15.4868 18.7415C14.7459 18.7415 14.1303 19.319 14.1303 20.0475C14.1303 20.7632 14.7582 21.3531 15.4868 21.3531Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/errorOutline.612c2d581692f10484859776084f9de1.svg";
export { ForwardRef as ReactComponent };